var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"us-contact"}},[_c('section',{staticClass:"contact"},[_c('h2',[_vm._v("Need more help? Contact us")]),_c('div',{staticClass:"mail-wrapper"},[_c('div',{staticClass:"mail-icon bg-contain"}),_c('a',{staticClass:"mail",attrs:{"href":"mailto:service@ins.to"}},[_vm._v("service@ins.to")])])])])
}]

export { render, staticRenderFns }